import styled from 'styled-components';
import { common, fonts } from 'themes/default';

const StyledTable = styled.table`
  width: 100%;
  border-spacing: 1px;
  position: relative;
`;

const StyledTHead = styled.thead`
  text-align: center;
`;

const StyledTh = styled.th`
  ${fonts.BodyLBold}
  text-align: center;
  line-height: normal;
  background-color: ${(props) => props.columnBackgroundColor};
  height: ${(props) => props.headerHeight && props.headerHeight + 'px'};
  cursor: ${(props) => (props.sortable ? 'pointer' : 'auto')};
  color: ${(props) => props.columnColor};
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
`;

const StyledTr = styled.tr`
  td {
    background-color: ${common.tables.row.backgroundColour};
    color: ${common.tables.row.fontColour};
  }

  ${({ doAlternate }) => {
    if (doAlternate) {
      return `&:nth-child(even) td {
        background-color: ${common.tables.rowAlternate.backgroundColour};
        color: ${common.tables.rowAlternate.fontColour};
      }`;
    }
  }}
`;

const StyledTd = styled.td`
  ${fonts.BodyM}
  line-height: normal;
  box-sizing: border-box;
  text-align: center;
  overflow-wrap: anywhere;
  word-break: break-all;
  vertical-align: inherit;
`;

export { StyledTable, StyledTHead, StyledTh, StyledTr, StyledTd };
